import React from 'react';
import './Total.css';

const Total = ({ amount }) => {
    return (
        <div className="billtab-total-container">
            <span className="billtab-total-count">${amount.toFixed(2)}</span>
            <span className="billtab-total-label">Total</span>
        </div>
    );
};

export default Total;
